import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { APIProcessorImpl } from './apiProcessor';
import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { StatusCodes } from '../util/statuscodes';
import { RoutingFeatures } from '../../ui/components/navigation/routingfeature';

export class SixdeeCRBTAPIProcessor<T extends APIRequest, R extends APIResponse> extends APIProcessorImpl<T, R>
{
     private request: T;

     execute(request: T): void
     {
          this.request = request;

          if(this.getContext().getValidateKnownFailures().isTokenExpired(
                        this.getContext().getUserContext().getExpiry())) 
          {
               this.refreshToken();
          }
          else
          {
               super.execute(request);
          }
     }
     
    onFailure(responseMapper: ResponseMapper): void 
    {
        console.log("API Failure invoked: Status Code: " + responseMapper.getStatusCode());
        
        if(+responseMapper.getStatusCode() === StatusCodes.REGENERATE_TOKEN)
        {
           this.refreshToken();
        }
        else if(+responseMapper.getStatusCode() === StatusCodes.UN_AUTHORISED)
        {
              this.getContext().getValidateKnownFailures().handleUnAuthorised();
        }
    }

    private refreshToken()
    {
          this.getContext().getValidateKnownFailures().refreshToken()
          .onSuccess(() =>
          {
               super.execute(this.request);
          })
          .onFailure((responseMapper: ResponseMapper)=> 
          {
              this.getContext().getRedirectionHandler().routeNextFeature(RoutingFeatures.LOGIN, false);
          });
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/sixdeecrbtapiprocessor.ts